import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";

const OurCustomers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await fetch("https://api.spadserver.com/api/quotes");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const result = await response.json();
        setCustomers(result.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomers();
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="text-center text-red-600">Error: {error}</div>;
  }

  if (customers.length === 0) {
    return <div className="text-center">No data available</div>;
  }

  return (
    <div className="py-10 px-4 sm:px-8 md:px-16 text-white text-justify">
      <h1 className="text-lg md:text-3xl mb-4 text-white text-center">
        نظرات برخی از مشتریان
      </h1>
      <p className="text-center mb-12 sm:mb-16 md:mb-24">
        مشتریانی که به ما اعتماد کردند.
      </p>
      <div className="flex justify-center">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8 max-w-screen-xl mx-auto">
          {customers.map((customer) => (
            <div
              key={customer.id}
              className="relative flex flex-col items-center mb-20"
            >
              <div className="absolute top-[-50px] w-20 h-20 sm:w-24 sm:h-24">
                <img
                  src={`https://admin.spadserver.com/storage/${
                    customer.photo?.path || ""
                  }`}
                  alt={customer.photo?.title || "Customer Image"}
                  className="w-full h-full object-contain rounded-full border-[1px] border-gray-300"
                />
              </div>
              <div className="border rounded-lg p-6 sm:p-8 shadow-lg bg-transparent mt-12 sm:mt-16 w-full text-center flex flex-col justify-between min-h-[180px] sm:min-h-[200px]">
                <div
                  className="text-gray-200 text-xs sm:text-sm mb-4"
                  dangerouslySetInnerHTML={{ __html: customer.description }}
                />
              </div>
              <h2 className="text-base sm:text-lg font-semibold text-white mt-4">
                {customer.title}
              </h2>
              <p className="text-gray-400 text-sm sm:text-base mb-2">
                {customer.sub_title}
              </p>
              <div className="flex justify-center">
                <span className="text-blue-400">★★★★★</span>{" "}
                {/* Adjust this if ratings are dynamic */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurCustomers;
